<div class="flyout-general-info-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="!expandedTab || expandedTab === 'general-info'" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <img class="header-icon" src="/assets/img/icons_fl/user-analytics.svg" width="32px" height="32px" />
        <span>{{ "flyout.general.title" | translate }}</span>
      </mat-expansion-panel-header>

      @if (countryCode) {
        <div class="expansion-panel-row no-border">
          <div class="label">
            <span>{{ "flyout.general.country" | translate }}</span>
          </div>
          <div class="value">
            <img class="value-icon left" src="/assets/img/flags_iso_svg/{{ countryCode | lowercase }}.svg" height="16px" />
            @if (geoLocation) {
              <span class="regular">{{ geoLocation }}</span>
            }
            @if (!geoLocation) {
              <span class="regular">{{ "countries." + countryCode | lowercase | translate }}</span>
            }
          </div>
        </div>
      }

      @if (consentEvents && consentEvents.length > 0) {
        <div class="expansion-panel-row no-border">
          <div class="label">
            <span>{{ "flyout.general.consent" | translate }}</span>
          </div>
          <div class="value link-color" (click)="clickToScroll('flyout-consents')">
            <span class="clickable">
              {{ consentEvents.length }}
              @if (consentEvents.length > 1) {
                <span>{{ "flyout.general.consents" | translate }}</span>
              }
              @if (consentEvents.length === 1) {
                <span>{{ "flyout.consent.title" | translate }}</span>
              }
            </span>
          </div>
        </div>
      }

      @if (previousVisits || visits?.length > 0) {
        <div class="expansion-panel-row no-border">
          <div class="label">
            <span>{{ "flyout.general.visitsTotal" | translate }}</span>
          </div>
          <div class="value link-color" (click)="clickToScroll('flyout-sessions')">
            <span class="clickable" [matTooltip]="('flyout.general.uniqueVisitors' | translate) + ': ' + uniqueVisitors" [matTooltipDisabled]="!uniqueVisitors">
              <span>{{ previousVisits ?? visits.length }}</span>
              {{ "flyout.general.visits" | translate }}
            </span>
          </div>
        </div>
      }

      @if (organizationName) {
        <div class="expansion-panel-row no-border">
          <div class="label">
            <span>{{ "flyout.general.organisation" | translate }}</span>
          </div>
          <div class="value link-color" (click)="clickToScroll('flyout-device-info')">
            <span class="regular">{{ organizationName }}</span>
          </div>
        </div>
      }

      @if (devices && devices.length > 0) {
        <div class="expansion-panel-row no-border">
          <div class="label">
            <span>{{ "flyout.general.technology" | translate }}</span>
          </div>
          @if (!isSession) {
            <div class="value link-color" (click)="clickToScroll('flyout-device-info')">
              <span class="clickable">{{ devices.length }}&nbsp;{{ "flyout.general.devices" | translate }}</span>
              @if (hasMobileDevice) {
                <img class="value-icon" src="/assets/img/icons_fl/mobile_2.svg" height="20px" />
              }
              @if (hasDesktopDevice) {
                <img class="value-icon" src="/assets/img/icons_fl/laptop_2.svg" height="16px" />
              }
            </div>
          }
          @if (isSession) {
            <div class="value device">
              @if (nativeAppPlatform) {
                <div>
                  <span class="image-spacer">{{ nativeAppPlatform }},</span>
                </div>
              } @else {
                <div>
                  @if (browserType === "chrome") {
                    <img class="browser-icon" src="/assets/img/devices/chrome.svg" />
                  }
                  @if (browserType === "explorer") {
                    <img class="browser-icon" src="/assets/img/devices/internet-explorer.svg" />
                  }
                  @if (browserType === "edge") {
                    <img class="browser-icon" src="/assets/img/devices/edge.svg" />
                  }
                  @if (browserType === "safari") {
                    <img class="browser-icon" src="/assets/img/devices/safari.svg" />
                  }
                  @if (browserType === "firefox") {
                    <img class="browser-icon" src="/assets/img/devices/firefox.svg" />
                  }
                  @if (browserType === "opera") {
                    <img class="browser-icon" src="/assets/img/devices/opera.svg" />
                  }
                  @if (browserType === "blackberry") {
                    <img class="browser-icon" src="/assets/img/devices/blackberry.svg" />
                  }
                  <span class="image-spacer">{{ sessionDetails?.webBrowser }},</span>
                </div>
              }
              <div>
                @if (sessionDetails?.screenResolution) {
                  <span class="image-spacer">{{ sessionDetails?.screenResolution }},</span>
                }
              </div>
              <div>
                @if (osType === "windows") {
                  <img class="browser-icon" src="/assets/img/devices/windows.svg" />
                }
                @if (osType === "apple") {
                  <img class="browser-icon" src="/assets/img/devices/apple.svg" />
                }
                @if (osType === "linux") {
                  <img class="browser-icon" src="/assets/img/devices/linux.svg" />
                }
                @if (osType === "android") {
                  <img class="browser-icon" src="/assets/img/devices/android.svg" />
                }
                @if (osType === "blackberry") {
                  <img class="browser-icon" src="/assets/img/devices/blackberry.svg" />
                }
                <span>{{ sessionDetails.operatingSystem }}</span>
              </div>
            </div>
          }
        </div>
      }
      @if (personVisits) {
        <div class="expansion-panel-row no-border">
          <div class="label">
            <span>{{ "flyout.general.previous-visits" | translate }}</span>
          </div>
          <div class="value link-color" (click)="openDetailsByUid()">
            <span class="clickable">{{ personVisits }}{{ "flyout.general.this-visitor" | translate }}</span>
          </div>
        </div>
      }
      @if (totalVisits && !isIsp && visitsTimespan && organizationName) {
        <div class="expansion-panel-row no-border">
          <div class="label">
            <span>{{ "flyout.general.organisation-label" | translate }}</span>
          </div>
          <div class="value">
            <span class="regular">
              {{ organizationName }} ({{ totalVisits }}
              {{ "flyout.general.visits-in-last" | translate }}
              {{ visitsTimespan }}
              {{ "flyout.general.days" | translate }})
            </span>
          </div>
        </div>
      }
      @if (totalSalesVisits || totalSales) {
        <div class="expansion-panel-row no-border">
          <div class="label">
            <span>{{ "generic.sales" | translate }}</span>
          </div>
          <div class="value">
            <span>{{ isSession ? totalSalesVisits : totalSales }} {{ currentAccountCurrency }}</span>
            <span class="icon-helper">
              @if (!isSession) {
                <mat-icon [matTooltip]="'flyout.general.sales-hint' | translate">help_outline</mat-icon>
              }
              @if (isSession) {
                <mat-icon [matTooltip]="'flyout.general.sales-hint-visit' | translate">help_outline</mat-icon>
              }
            </span>
          </div>
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
